import axios from 'axios'
import { API_URL, AUTH } from '../Constants'
import SwalErrorCustom from './swal-error'
export const postAuth = async ({ url, auth, path, body = {} }) => {
  return await axios
    .post(`${url}${path}`, body, {
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json',
        authorization: auth
      }
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      throw new Error(error.message)
    })
}

export const getAuth = async (path, params = {}) => {
  return await axios({
    method: 'GET',
    url: `${API_URL}api/${path}`,
    headers: {
      authorization: AUTH
    },
    params
  })
    .then((response) => {
      if (!response) return
      return response.data
    })
    .catch((error) => {
      SwalErrorCustom(error)
    })
}
